import { render, staticRenderFns } from "./addDaHuoV4.vue?vue&type=template&id=42c63efb&scoped=true&"
import script from "./addDaHuoV4.vue?vue&type=script&lang=js&"
export * from "./addDaHuoV4.vue?vue&type=script&lang=js&"
import style0 from "./addDaHuoV4.vue?vue&type=style&index=0&id=42c63efb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c63efb",
  null
  
)

export default component.exports